<template>
  <div class="d-inline">
    <v-btn color="green" dark @click="open" v-if="canAdd">
      <v-icon left>mdi-account-plus</v-icon>Add Lead
    </v-btn>
    <v-dialog v-model="dialog" persistent width="560" scrollable>
      <v-card>
        <ModalHeader
          title="Add Lead"
          icon="mdi-account-plus"
          subtitle="Capture a new prospect"
          @close="dialog = false"
        />
        <v-divider></v-divider>
        <v-card-text class="pa-4" style="max-height: 70vh">
          <v-form ref="form" class="mt-3">
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  outlined
                  dense
                  label="Customer Name *"
                  v-model="form.customer_name"
                  :rules="[(v) => !!v || 'Name is required']"
                  prepend-icon="mdi-account"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  outlined
                  dense
                  label="Contact Number *"
                  v-model="form.contact_number"
                  :rules="[(v) => !!v || 'Contact number is required']"
                  prepend-icon="mdi-phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  outlined
                  dense
                  label="Source"
                  v-model="form.lead_source_id"
                  :items="customer_sources"
                  item-text="name"
                  item-value="id"
                  prepend-icon="mdi-bullhorn"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  outlined
                  dense
                  label="Interested In *"
                  v-model="form.category"
                  :items="categories"
                  :rules="[(v) => !!v || 'Pick a category']"
                  prepend-icon="mdi-cart"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  outlined
                  dense
                  label="Grade"
                  v-model="form.grade"
                  :items="grades"
                  prepend-icon="mdi-label"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-center">
                <v-switch
                  v-model="form.converted"
                  label="Converted to sale?"
                  color="green"
                  inset
                  hide-details
                  class="mt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6" v-if="form.converted">
                <v-text-field
                  outlined
                  dense
                  label="Sale Amount (₱)"
                  v-model="form.sale_amount"
                  type="number"
                  prepend-icon="mdi-cash"
                ></v-text-field>
              </v-col>
            </v-row>
            <p class="caption grey--text mb-0 mt-1">
              Add the category-specific details afterwards from the row's
              <v-icon x-small>mdi-clipboard-text</v-icon> Details button.
            </p>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-btn color="green" dark depressed @click="submit" :loading="loading"
            >Save</v-btn
          >
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text mb-0">addLeadModal.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { LEAD_CATEGORIES, LEAD_GRADES } from "@/config/leadCategoryTemplates";

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      customer_sources: [],
      categories: LEAD_CATEGORIES,
      grades: LEAD_GRADES,
      form: this.blankForm(),
    };
  },
  computed: {
    ...mapGetters({ hasPermission: "permission/hasPermission" }),
    canAdd() {
      return this.hasPermission("leads.add");
    },
  },
  methods: {
    ...mapActions({ add_lead: "lead/add_lead" }),
    blankForm() {
      return {
        customer_name: "",
        contact_number: "",
        lead_source_id: null,
        category: null,
        grade: null,
        converted: false,
        sale_amount: null,
      };
    },
    async open() {
      this.dialog = true;
      if (this.customer_sources.length === 0) {
        try {
          const res = await axios.get("/customer_sources");
          this.customer_sources = res.data;
        } catch (e) {
          // non-fatal; source is optional on a lead
        }
      }
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        await this.add_lead({
          ...this.form,
          sale_amount: this.form.converted ? this.form.sale_amount : null,
        });
        this.$alert({
          title: "Success",
          message: "Lead created.",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.$refs.form.resetValidation();
        this.form = this.blankForm();
        this.dialog = false;
        this.$emit("saved");
      } catch (e) {
        this.$alert({
          title: "Error",
          message: e?.response?.data?.message || "Failed to create lead.",
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
